export default "__VITE_ASSET__5ilWSVRg__"